/* "So funktioniert Plume": a short story after the first start, made of small looping scenes
   (pure HTML/CSS, like GIFs but sharp and themed). Plays itself, can be paused, skipped and
   replayed later. The same scenes also fill the empty screens (students, invoices). */
import { t } from './i18n/index.js';
import { S, persist } from './state.js';
import { esc } from './ui.js';

const ic={
  check:'<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  bell:'<svg viewBox="0 0 24 24"><path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z"/><path d="M10 20.5a2 2 0 0 0 4 0"/></svg>',
  feather:'<svg viewBox="96 96 320 340"><path d="M352 112c-72 8-136 56-168 120-20.8 41.6-28.8 88-31.2 132.8l-4.8 39.2c-.8 7.2 7.2 12.8 13.6 8.8l33.6-20.8C240 368 284 344 316 308c44-48 56-128 36-196z"/></svg>',
  rep:'<svg viewBox="0 0 24 24"><path d="M4 12a8 8 0 0 1 13.7-5.6L20 9M20 4v5h-5M20 12a8 8 0 0 1-13.7 5.6L4 15M4 20v-5h5"/></svg>',
};
const L=k=>esc(t(k));

/* ---------- the scenes ---------- */
export const SCENES={
  team:()=>`<div class="sc sc-team">
    <div class="tm-col">${['Sara K.','Nour B.','Tom R.'].map((n,i)=>`<div class="tm-t t${i}"><span class="av" style="--c:${['#C2472F','#217A52','#8248B8'][i]}">${n[0]}${n.split(' ')[1][0]}</span><b>${esc(n)}</b><em>${ic.check}</em></div>`).join('')}</div>
    <div class="tm-stu"><span class="av sm" style="--c:#2242C8">AM</span><span class="nm">Anna M.</span></div>
    <div class="tm-stu s2"><span class="av sm" style="--c:#B8790E">BK</span><span class="nm">Ben K.</span></div>
    <div class="cursor"></div>
  </div>`,
  student:()=>`<div class="sc sc-student">
    <div class="st-card">
      <div class="st-lbl">${L('story.name')}</div>
      <div class="st-field"><span class="st-type">Anna Müller</span><i class="caret"></i></div>
      <div class="st-lbl">${L('stu.subjects')}</div>
      <div class="st-chips"><span class="c1">Mathe</span><span class="c2">Englisch</span><span class="c3">+</span></div>
      <div class="st-btn">${L('c.save')}</div>
    </div>
    <div class="st-row"><span class="av" style="--c:#2242C8">AM</span><b>Anna Müller</b><small>Mathe, Englisch</small><em>${ic.check}</em></div>
    <div class="cursor"></div>
  </div>`,
  plan:()=>`<div class="sc sc-plan">
    <div class="pl-head">${['Mo','Di','Mi','Do','Fr'].map(d=>`<span>${d}</span>`).join('')}</div>
    <div class="pl-grid">${[0,1,2,3].map(w=>`<div class="pl-week">${[0,1,2,3,4].map(d=>`<span class="pl-day">${d===1?`<i class="pl-l a w${w}">15:00<b>Anna</b></i>`:''}${d===3&&w<3?`<i class="pl-l b w${w}">16:30<b>Ben</b></i>`:''}</span>`).join('')}</div>`).join('')}</div>
    <div class="pl-chip">${ic.rep}${L('story.weekly')}</div>
  </div>`,
  remind:()=>`<div class="sc sc-remind">
    <div class="ph"><div class="ph-time">14:02</div><div class="ph-date">${L('story.day')}</div>
      <div class="ph-n n1"><span class="ph-ic">${ic.feather}</span><div><b>${L('story.n1t')}</b><small>${L('story.n1b')}</small></div></div>
      <div class="ph-n n2"><span class="ph-ic">${ic.feather}</span><div><b>${L('story.n2t')}</b><small>${L('story.n2b')}</small></div></div>
    </div>
  </div>`,
  recap:()=>`<div class="sc sc-recap">
    <div class="rc-timer"><svg viewBox="0 0 64 64"><circle class="tr" cx="32" cy="32" r="27"/><circle class="tp" cx="32" cy="32" r="27"/></svg><b>60:00</b><small>Anna</small></div>
    <div class="rc-card">
      <div class="st-lbl">${L('sum.topics')}</div>
      <div class="st-chips"><span class="c1">Brüche</span><span class="c2">Kürzen</span><span class="c3">Erweitern</span></div>
      <div class="st-lbl">${L('sum.homework')}</div>
      <div class="st-field"><span class="st-type hw">S. 34, Nr. 2 und 3</span><i class="caret"></i></div>
      <div class="rc-ok">${ic.check}${L('story.saved')}</div>
    </div>
  </div>`,
  invoice:()=>`<div class="sc sc-invoice">
    <div class="iv-list">${['Di 7.','Di 14.','Di 21.','Di 28.'].map((d,i)=>`<div class="iv-row r${i}"><span class="box">${ic.check}</span>${esc(d)} Okt.<b>60 Min.</b></div>`).join('')}</div>
    <div class="iv-paper">
      <div class="iv-h"><b>${L('story.invoiceNo')}</b><span>Anna Müller</span></div>
      <div class="iv-l"></div><div class="iv-l"></div><div class="iv-l s"></div>
      <div class="iv-tot"><span>${L('story.total')}</span><b>120,00 €</b></div>
      <div class="iv-qr"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>
      <div class="iv-stamp">${L('story.paid')}</div>
    </div>
  </div>`,
};

const CHAPTERS=school=>[...(school?['team']:[]),'student','plan','remind','recap','invoice'];
const DUR=6200;   // one scene loop = one chapter

export function storyMini(name,cls=''){return `<div class="story-mini ${cls}" aria-hidden="true">${SCENES[name]()}</div>`}

/* ---------- the story ---------- */
export function openStory({school=!!(S.settings&&S.settings.school),onDone}={}){
  if(document.querySelector('.story'))return;
  const still=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ch=CHAPTERS(school);
  const root=document.createElement('div');
  root.className='story'+(still?' still':'');root.setAttribute('role','dialog');root.setAttribute('aria-modal','true');root.setAttribute('aria-labelledby','st-h');
  root.innerHTML=`<div class="sy-card">
    <div class="sy-bars" role="tablist" aria-label="${L('story.title')}">${ch.map((c,i)=>`<button type="button" class="sy-bar" role="tab" data-go="${i}" aria-label="${esc(t('story.'+c+'.t'))}"><i></i></button>`).join('')}<button type="button" class="sy-bar end" data-go="${ch.length}" aria-label="${L('story.end.t')}"><i></i></button></div>
    <div class="sy-top"><span class="sy-k">${L('story.title')}</span><button type="button" class="sy-skip" data-sy="skip">${L('story.skip')}</button></div>
    <div class="sy-stage" aria-hidden="true"></div>
    <div class="sy-text" aria-live="polite"><div class="sy-n"></div><h2 id="st-h"></h2><p></p></div>
    <div class="sy-nav">
      <button type="button" class="iconbtn" data-sy="prev" aria-label="${L('story.prev')}"><svg viewBox="0 0 24 24"><path d="m14.5 6-6 6 6 6"/></svg></button>
      <button type="button" class="iconbtn" data-sy="pause" aria-label="${L('story.pause')}"><svg viewBox="0 0 24 24" class="i-pause"><path d="M9 6v12M15 6v12"/></svg><svg viewBox="0 0 24 24" class="i-play"><path d="M8 5.5v13l11-6.5z"/></svg></button>
      <button type="button" class="btn primary" data-sy="next">${L('story.next')}</button>
    </div>
  </div>`;
  document.body.appendChild(root);
  const q=x=>root.querySelector(x);
  let i=0,el=0,last=0,paused=still,raf=0;
  const bars=[...root.querySelectorAll('.sy-bar')];
  function finish(go){
    cancelAnimationFrame(raf);removeEventListener('keydown',keys);
    S.settings.dismissed=S.settings.dismissed||{};S.settings.dismissed.story=true;persist();
    root.classList.add('out');setTimeout(()=>{root.remove();onDone&&onDone(go)},380);
  }
  function show(n){
    i=Math.max(0,Math.min(n,ch.length));el=0;
    bars.forEach((b,k)=>{b.classList.toggle('done',k<i);b.classList.toggle('on',k===i);b.setAttribute('aria-selected',k===i);b.querySelector('i').style.transform=k<i?'scaleX(1)':'scaleX(0)'});
    const stage=q('.sy-stage');
    if(i<ch.length){
      const c=ch[i];
      stage.innerHTML=SCENES[c]();stage.className='sy-stage';
      q('.sy-n').textContent=t('story.step',{n:i+1,of:ch.length});
      q('#st-h').textContent=t('story.'+c+'.t');q('.sy-text p').textContent=t('story.'+c+'.d');
      q('[data-sy=next]').textContent=t('story.next');q('[data-sy=next]').classList.remove('big');
      root.classList.remove('last');
    }else{
      stage.innerHTML=`<div class="sy-final"><span class="sy-fm">${ic.feather}</span></div>`;stage.className='sy-stage final';
      q('.sy-n').textContent='';
      q('#st-h').textContent=t('story.end.t');q('.sy-text p').textContent=t(school?'story.end.dSchool':'story.end.d');
      q('[data-sy=next]').textContent=t(school?'story.end.goSchool':'story.end.go');
      root.classList.add('last');
    }
    q('[data-sy=prev]').disabled=i===0;
  }
  function tick(ts){
    if(!last)last=ts;const dt=ts-last;last=ts;
    if(!paused&&i<ch.length){
      el+=dt;const p=Math.min(1,el/DUR);bars[i].querySelector('i').style.transform='scaleX('+p.toFixed(3)+')';
      if(el>=DUR)show(i+1);
    }
    raf=requestAnimationFrame(tick);
  }
  const setPause=v=>{paused=v;root.classList.toggle('paused',v);q('[data-sy=pause]').setAttribute('aria-label',t(v?'story.play':'story.pause'))};
  function keys(e){
    if(e.key==='Escape')finish(false);
    else if(e.key==='ArrowRight')show(i+1);
    else if(e.key==='ArrowLeft')show(i-1);
    else if(e.key===' '&&e.target===document.body){e.preventDefault();setPause(!paused)}
  }
  addEventListener('keydown',keys);
  bars.forEach(b=>b.onclick=()=>show(+b.dataset.go));
  q('[data-sy=prev]').onclick=()=>show(i-1);
  q('[data-sy=next]').onclick=()=>{if(i>=ch.length)finish(true);else show(i+1)};
  q('[data-sy=skip]').onclick=()=>finish(false);
  q('[data-sy=pause]').onclick=()=>setPause(!paused);
  // hold the scene to look closer, like stories in other apps
  const stage=q('.sy-stage');let held=false;
  stage.addEventListener('pointerdown',()=>{if(!paused){held=true;setPause(true)}});
  addEventListener('pointerup',()=>{if(held){held=false;setPause(false)}});
  setPause(paused);show(0);raf=requestAnimationFrame(tick);
  setTimeout(()=>q('[data-sy=next]').focus(),60);
}
